import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  editIndex: "",
  fieldRecursiveName: "",
  minLength: "",
  maxLength: "",
  formField: {},
  savedFormFields: [],
  saveData: [],
  recursiveFormData: {},
};

export const fieldRecursiveReducer = createSlice({
  name: "fieldRecursiveReducer",
  initialState,
  reducers: {
    setAddSaveData: (state, action) => {
      state.saveData = [...state.saveData, action.payload];
    },
    setSaveData: (state, action) => {
      state.saveData = action.payload;
    },
    setFormField: (state, action) => {
      state.formField = action.payload;
    },
    setAddSavedFormFields: (state, action) => {
      state.savedFormFields = [...state.savedFormFields, action.payload];
    },
    setInitialRecursiveFormData: (state, action) => {
      state.recursiveFormData = {
        ...action.payload,
      };
    },
    setFieldRecursiveName: (state, action) => {
      state.fieldRecursiveName = action.payload;
    },
    setRecursiveFormData: (state, action) => {
      state.savedFormFields[state.editIndex] = {
        ...state.savedFormFields[state.editIndex],
        [action.payload.key]: action.payload.value,
      };
      if (action.payload.key === 'id' || action.payload.key === 'name' || action.payload.key === 'type' || action.payload.key === 'value' || action.payload.key === 'index')
        state.saveData[state.editIndex] = {
          ...state.saveData[state.editIndex],
          [action.payload.key]: action.payload.value,
        }
    },
    setEditIndex: (state, action) => {
      state.editIndex = action.payload;
    },
    setEditSaveData: (state, action) => {
      state.saveData.splice(state.editIndex, 1, { ...state.recursiveFormData });
    },
    setDeleteSaveData: (state, action) => {
      state.saveData = [
        ...state.saveData.filter((item, i) => i !== action.payload),
      ];
    },
    setDeleteFormFields: (state, action) => {
      state.savedFormFields = [
        ...state.savedFormFields.filter((item, i) => i !== action.payload),
      ];
    },
    clearFieldRecursionData: (state, action) => {
      state.savedFormFields = []
      state.saveData = []
      state.fieldRecursiveName = ""
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  setAddSaveData,
  setSaveData,
  setFormField,
  setAddSavedFormFields,
  setInitialRecursiveFormData,
  setRecursiveFormData,
  setEditIndex,
  setEditSaveData,
  setDeleteSaveData,
  setDeleteFormFields,
  setFieldRecursiveName,
  clearFieldRecursionData
} = fieldRecursiveReducer.actions;

export default fieldRecursiveReducer.reducer;
